export default {
    person: {
        citizenship: 'Гражданство',
        lastEmployer: 'Последнее место работы',
        untilNow: 'по н.в.',
        working: 'История',
        institute: 'Учебное заведение',
        graduation: 'Год окончания',
        experience: 'Опыт работы',
        organization: 'Компания',
        position: 'Позиция',
        department: 'Отдел',
        speciality: 'Специальность',
        education: {
            title: 'Образование'
        },
        work: {
            title: 'Работа'
        },
        contacts: {
            title: 'Контакты'
        },
        address: {
            title: 'Адрес'
        },
        additional: {
            title: 'Дополнительная информация'
        },
        comments: 'Комментарии',
        fullName: 'ФИО',
        projects: 'Проекты',
        tags: 'Метки',
        phone: 'Телефон',
    },
};
